import { authClient, API } from "../index";

// Get all categorias
export const getCategorias = () => {
  return authClient().get(`${API}/categoria?getDisabled=true`);
};

// Get categoria by id
export const getCategoriaById = (id) => {
  return authClient().get(`${API}/categoria/${id}`);
};

// Delete categoria
export const deleteCategoria = (id) => {
  return authClient().delete(`${API}/categoria/${id}`);
};

// Create categoria
export const postCategoria = async (categoria) => {
  return authClient().post(`${API}/categoria`, categoria);
};

// Update categoria
export const updateCategoria = async (id, categoria) => {
  return authClient().put(`${API}/categoria/${id}`, categoria);
};

// Change status categoria
export const changeStatusCategoria = async (id, active) => {
  return authClient().put(`${API}/categoria/change-status/${id}`, { active });
};
